import { PayBridge } from '@apis/index'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Container, IconWrapper, Message, Meta, Spinner, Title } from './style'

// Isolated return page for PayBridge checkout sessions. PayBridge redirects
// here with ?session_id=...&status=success&payment_id=... after payment.
const PayBridgeSuccess = () => {
  const location = useLocation()
  const [syncing, setSyncing] = useState(true)

  const queryParams = new URLSearchParams(location.search)
  const sessionId = queryParams.get('session_id')
  const status = queryParams.get('status')
  const paymentId = queryParams.get('payment_id')

  useEffect(() => {
    const sync = async () => {
      if (!sessionId) {
        setSyncing(false)
        return
      }
      try {
        await PayBridge.syncSession({ id: sessionId })
      } catch (error) {
        console.error(error)
      } finally {
        setSyncing(false)
      }
    }
    sync()
  }, [sessionId])

  if (syncing) {
    return (
      <Container>
        <IconWrapper $tone="pending">
          <Spinner />
        </IconWrapper>
        <Title>Confirming your payment...</Title>
        <Message>
          Please wait while we confirm your payment with PayBridge.
        </Message>
      </Container>
    )
  }

  if (status && status !== 'success') {
    return (
      <Container>
        <IconWrapper $tone="pending">
          <svg viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
            />
          </svg>
        </IconWrapper>
        <Title>Payment Not Completed</Title>
        <Message>
          Your payment status came back as "{status}". If you completed the
          payment, it may still be processing.
        </Message>
        {sessionId && <Meta>Session: {sessionId}</Meta>}
      </Container>
    )
  }

  return (
    <Container>
      <IconWrapper $tone="success">
        <svg viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
          />
        </svg>
      </IconWrapper>
      <Title>Payment Successful!</Title>
      <Message>
        Thank you for your purchase. Your wallet will reflect the loaded amount
        shortly.
      </Message>
      {(sessionId || paymentId) && (
        <Meta>
          {sessionId && <>Session: {sessionId}</>}
          {sessionId && paymentId && <br />}
          {paymentId && <>Payment: {paymentId}</>}
        </Meta>
      )}
    </Container>
  )
}

export default PayBridgeSuccess
